import assetsI18nSettings from './settings.json';
import { getTranslationFile } from '@innovyze/lib_asset_schema';
// @ts-expect-error missing type definitions
import libAmCommonI18nSettings from '@innovyze/lib-am-common/Translations';
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { locales } from '@innovyze/stylovyze';
// @ts-ignore
import { ns as mapComponentsI18nSettings } from '@innovyze/map-components/Translations';
// @ts-ignore
import stylovyzeI18nSettings from '@innovyze/stylovyze/translations/Translations.json';

export const globalization = {
	bundles: [
		...locales.map((locale: string) => ({
			language: locale,
			namespace: assetsI18nSettings.ns,
			file: import(`../../data/translations/${locale}.json`),
		})),
		...locales.map((locale: string) => ({
			language: locale,
			namespace: stylovyzeI18nSettings.ns,
			file: import(`@innovyze/stylovyze/translations/${locale}.json`),
		})),
		...locales.map((locale: string) => ({
			language: locale,
			namespace: libAmCommonI18nSettings.ns,
			file: import(`@innovyze/lib-am-common/translations/${locale}.json`),
		})),
		...locales.map((locale: string) => ({
			language: locale,
			namespace: mapComponentsI18nSettings,
			file: import(
				`@innovyze/map-components/translations/${locale}.json`
			),
		})),
		...locales.map((locale: string) => ({
			language: locale,
			namespace: 'lib-asset-schema',
			file: getTranslationFile(locale),
		})),
	],
};
